export const TOKEN_KEY = "token";
export const COMPAMY_ID = "compamy_selected";
